import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const ipSchema = z.object({
  id: z.string(),
  address: z.string(),
  countryId: z.string(),
  createdAt: z.coerce.date(),
});

export class IpDto extends createZodDto(ipSchema) {}
